var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoginArw(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "login-arw",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 62.405,
    height: 17.608,
    viewBox: "0 0 62.405 17.608",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8",
    "data-name": "Rectangle 8",
    width: 62.405,
    height: 17.608,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_11",
    "data-name": "Group 11",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    "data-name": "Path 21",
    d: "M75.576,0A37.259,37.259,0,0,1,80.2,3.186c1.427,1,2.813,2.049,4.215,3.078a3.015,3.015,0,0,1,.021,5.168q-3.729,2.741-7.473,5.464a2.921,2.921,0,0,1-1.982.706,2.4,2.4,0,0,1-2.47-2.6c-.032-.854,0-1.71-.011-2.566-.008-.952-.393-1.329-1.368-1.332-1.7-.006-3.4,0-5.1,0a2.23,2.23,0,1,1-.025-4.437c1.7-.005,3.4,0,5.1,0,1.015,0,1.385-.373,1.393-1.378,0-.624.043-1.251-.007-1.871A3.026,3.026,0,0,1,74.6,0Z",
    transform: "translate(-23.485 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    "data-name": "Path 22",
    d: "M0,12.5c.109-.023.123-.11.154-.2A2.265,2.265,0,0,1,2.662,10.56q6.036,0,12.073,0,9.281,0,18.563,0a2.217,2.217,0,0,1,.624,4.369,3.813,3.813,0,0,1-.9.066c-9.863,0-19.726-.023-29.588.028C1.808,15.033.565,14.714,0,13.057Z",
    transform: "translate(9 -3.901)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginArw);
export default __webpack_public_path__ + "static/media/login-arw.1257c8fdeb99d0ca67d75d9d356d4823.svg";
export { ForwardRef as ReactComponent };